export default __webpack_public_path__ + "static/media/remove.7317db73.svg";